import modalConfirmation from '../modal-response/modal-response.view.html';

let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'SharedService',
    'ngAuthSettings',
    '$uibModal',
    '$timeout',
    'MetatagService'
];

class AdvertisementController {

    constructor($scope, $state, $rootScope, SharedService, ngAuthSettings, $uibModal, $timeout,MetatagService) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.ngAuthSettings = ngAuthSettings;
        this.$rootScope = $rootScope;
        this.SharedService = SharedService;
        this.slides={};
        this.data = {};
        this.MetatagService = MetatagService;
        this.active = 0;
        this.myInterval = 3000;
        this.noPause = false;
    }

    $onInit() {
        if(this.pageName){
            this.SharedService.getCMSBanners(this.pageName).then(response => {
                this.contentData = response;
                if (this.contentData.seo.title){
                  this.MetatagService.setTags(this.contentData.seo);
                }

            });
        }

        this.getBanners()
    }



    getBanners() {
        if(__env.adaptative){
          //this.slides=this.contentData.carrusel[this.positions];
        }else{
          if (this.typeContent == 'carrusel') {
            this.initBrandsCarousel();
          }
        }

    }

    initBrandsCarousel() {
    
        this.$timeout(function(){
    
          let  brandsItemsSlider = $('.brands-slider.owl-carousel');
          brandsItemsSlider.owlCarousel({
            items: 6,
            itemsDesktop : [1199,3],
            itemsDesktopSmall: [979,2],
            itemsTablet: [768,2],
            itemsMobile : [479,1],
            slideSpeed: 400,
            autoPlay: 5000,
            stopOnHover: true,
            navigation: false,
            pagination: false,
            responsive: true,
            mouseDrag: false,
            autoHeight : false
          }).data('navigationBtns', ['#brands-slider-prev', '#brands-slider-next']);
          brandsItemsSlider.each(function() {
            let $this = $(this),
              owlCarousel = $this.data('owlCarousel'),
              owlBtns = $this.data('navigationBtns'),
              prevBtn, nextBtn;
    
            if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
              return;
            }
    
            for(let key in owlBtns) {
              if (owlBtns[key].indexOf('next') === -1) {
                prevBtn = $(owlBtns[key]);
              }else {
                nextBtn = $(owlBtns[key]);
              }
            }
    
            prevBtn.on('click touchstart', function(e) {
              owlCarousel.prev();
              e.preventDefault();
            });
    
            nextBtn.on('click touchstart', function(e) {
              owlCarousel.next();
              e.preventDefault();
            });
          });
    
          $('.add-tooltip').tooltip();
        },1000);
      }

    // initBrandsCarousel() {

    //     this.$timeout(function () {

    //         let testimoniesItemsSlider = $('.advertisement-slider');
    //         testimoniesItemsSlider.owlCarousel({
    //             items: 1,
    //             itemsDesktop: [1199, 1],
    //             itemsDesktopSmall: [979, 1],
    //             itemsTablet: [768, 1],
    //             itemsMobile: [479, 1],
    //             slideSpeed: 400,
    //             autoPlay: 8000,
    //             stopOnHover: true,
    //             navigation: false,
    //             pagination: false,
    //             responsive: true,
    //             mouseDrag: false,
    //             autoHeight: false
    //         }).data('navigationBtns', ["#slider-prev", "#slider-next"]);
    //         testimoniesItemsSlider.each(function () {
    //             let $this = $(this),
    //                 owlCarousel = $this.data('owlCarousel'),
    //                 owlBtns = $this.data('navigationBtns'),
    //                 prevBtn, nextBtn;

    //             if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
    //                 return;
    //             }

    //             for (let key in owlBtns) {
    //                 if (owlBtns[key].indexOf('next') === -1) {
    //                     prevBtn = $(owlBtns[key]);
    //                 } else {
    //                     nextBtn = $(owlBtns[key]);
    //                 }
    //             }

    //             prevBtn.on('click touchstart', function (e) {
    //                 owlCarousel.prev();
    //                 e.preventDefault();
    //             });

    //             nextBtn.on('click touchstart', function (e) {
    //                 owlCarousel.next();
    //                 e.preventDefault();
    //             });
    //         });

    //         $('.add-tooltip').tooltip();
    //     }, 1000);
    // }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

}

AdvertisementController.$inject = inject;

export default AdvertisementController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/advertisement/advertisement.controller.js
 **/